import { ComponentConfig } from '@measured/puck';
import { Item } from '../../../page-builder/interface/checkoutInterface';
import {
  MarginProps,
  marginFields,
} from '../../../page-builder/puck/reusable-props/margin';
import { UpSellVariant } from './UpSellVariant';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import CustomTooltip from '../../../components/common/tooltip';
import {
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { PlaceHolderField } from '../../puck/reusable-props/placeHolder';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import LoadingSpinner from '../shared/LoadingSpinner';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';

export type UpSellProps = {
  placeholder: {
    add: string;
    remove: string;
  };
  background: {
    color: string;
    isInherit: boolean;
  };
} & MarginProps &
  PaddingProps &
  showComponentProps;

export const UpSell = ({
  useAppSelector,
  useAppDispatch,
}: ReduxSelectorProps & ReduxDispatchProps): ComponentConfig<UpSellProps> => {
  return {
    label: (
      <CustomTooltip title="UpSell">
        <span>Up Sell</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      placeholder: {
        type: 'custom',
        label: 'Place Holder',
        render: ({ value, onChange }) => {
          return (
            <PlaceHolderField
              value={value}
              onChange={onChange}
              data={[
                { label: 'Add button', value: 'add' },
                { label: 'Remove button', value: 'remove' },
              ]}
            />
          );
        },
      },
      ...marginFields,
      ...paddingFields,
      ...backgroungFields,
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      placeholder: {
        add: 'Add',
        remove: 'Remove',
      },
    },
    render: ({
      margin,
      padding,
      showComponent,
      placeholder,
      background,
      editMode,
    }) => {
      const { preUpsellData, preupsellLoading } = useAppSelector(
        state => state.preUpSell,
      );
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      if (preupsellLoading)
        return (
          <div className="flex justify-center items-center bg-white bg-opacity-20">
            <LoadingSpinner />
          </div>
        );
      if (!preUpsellData || !preUpsellData?.length) return <></>;
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
              }}
              className={`overflow-hidden transition-all ease-in-out`}>
              <ul className="flex flex-col gap-y-1">
                {preUpsellData?.map((upSell: Item, index: number) => (
                  <div
                    key={index}
                    className="!rounded-lg !mb-4 !border-dashed border !border-black !shadow-lg">
                    <UpSellVariant
                      variant={upSell}
                      background={background}
                      placeholder={placeholder}
                      useAppSelector={useAppSelector}
                      useAppDispatch={useAppDispatch}
                      preUpsellData={preUpsellData}
                    />
                  </div>
                ))}
              </ul>
            </div>
          )}
        </>
      );
    },
  };
};
